import axios from 'axios';
import {config} from "../constants/constants";

let API_URL = config.url.PUBLIC_API

const instance = axios.create({baseURL: API_URL,});

export default instance;
